import * as React from "react";
import type { SVGProps } from "react";
const SvgCardLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 18.3H4.2a2.4 2.4 0 0 1-2.4-2.4v-9a2.4 2.4 0 0 1 2.4-2.4h14.4A2.4 2.4 0 0 1 21 6.9v1.8m-18.6 0h18M17.7 15v-1a1.5 1.5 0 1 1 3 0v1.5m-3.5 4h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1"
    />
  </svg>
);
export default SvgCardLock;
